
type Props = {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const BaseDatePicker: React.FC<Props> = ({ label, name, value, onChange }) => (
  <div className="form-group">
    <label>{label}</label>
    <input type="date" name={name} value={value} onChange={onChange} className="form-control" />
  </div>
);

export default BaseDatePicker;
